import logo from './platzi.webp';
import React from 'react';

import './App.css';

const defaultTodos = [
  {text: 'Ir al ICA', completed: false},
  {text: 'Lavar tenis', completed: false},
  {text: 'Confirmar perros en avión', completed: false},
  {text: 'Estudiar React', completed: true}
]

function App() {
  const [searchValue, setSearchValue] = React.useState('');
  const [todos, setTodos] = React.useState(defaultTodos);

  return (
    <>

      <TodoCounter total={todos.length} completed={todos.filter(todo => todo.completed).length} />
      <TodoSearch 
        searchValue={searchValue} 
        setSearchValue={setSearchValue} 
      />
      <TodoList>
        {defaultTodos.map(todo => (
          <TodoItem key={todo.text} text={todo.text} completed={todo.completed} />
        ))}
      </TodoList>

      <CreateTodoButton />


      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edita el archivo <code>src/App.js</code> y guarda para recargar.
        </p>
        <a
          className="App-link"
          href="https://platzi.com/reactjs"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </>
  );
}

function TodoCounter({total, completed}) {
  return (
    <h1>
      Has completado {completed} de {total} TODOs</h1>
  )
}

function TodoSearch({searchValue, setSearchValue}) {
  return (
    <input placeholder="Cebolla"
    className="todo-search"
    value={searchValue}
    onChange={(event) => {
      setSearchValue(event.target.value);
      console.table('Buscando TODOs para', event.target.value);
    } 
    }  />
  )
}

function TodoList(props) {
  return (
    <section>
      <ul>
        {props.children}
      </ul>
    </section>
  )
}

function CreateTodoButton() {
  return (
    <button 
      className="create-todo"
      onClick={() => console.log('Aquí se abrirá el modal para crear un TODO')}
      >
      +
    </button>
  )
} 

function TodoItem(props) {
  return (
    <li  className={props.completed ? 'completed' : 'pending'}>
      <span>{props.completed ? '✓' : '✗'}</span>
      <p>{props.text}</p>
      <span>
        {props.completed ? '✓' : '✗'}
      </span>
    </li>
  )
}

export default App;
